import i18n from "../../constants/i18n";
import getCoreUIStore from "../../stores/core/core-ui-store";
import { TEt3Button } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import Et3CustomizedButton from "./Et3CustomizedButton";

const Et3Button = withLiteObserverAndTheme<TEt3Button>((props) => {
  const { text, isEnabled, size, onClick, type, theme } = props;
  const { colors, unitX } = theme;
  const isButtonLocked = getCoreUIStore().buttonLocked.get();
  const fontType = size === "LARGE" ? "MEDIUM" : "BOLD";
  const fontSize = size === "LARGE" ? 24 : 18;
  const width = size === "LARGE" ? 280 : size === "MEDIUM" ? 200 : 116;
  const height =
    size === "LARGE" ? 45 : size === "MEDIUM" || size === "DEFAULT" ? 40 : 39;
  const isButtonEnabled = isButtonLocked ? false : isEnabled;
  const color = !isEnabled
    ? colors.all.davysGrey
    : type === "APPROVE"
      ? colors.all.seaGreen
      : type === "REJECT"
        ? colors.all.red
        : type === "GET"
          ? colors.all.bondiBlue
          : type === "WARN"
            ? colors.all.orange
            : type === "SEND"
              ? colors.all.bondiBlue
              : colors.all.gray;

  let divStyle = {
    borderRadius: unitX * 30,
    cursor: isButtonLocked ? "default" : "pointer"
  };

  if (size === "DEFAULT") {
    const divWidth = {
      width: "100%"
    };
    divStyle = { ...divStyle, ...divWidth };
  }

  return (
    <Et3CustomizedButton
      withShadow={true}
      width={width}
      height={height}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={color}
      style={{
        ...divStyle
      }}
      onClick={async () => {
        getCoreUIStore().buttonLocked.set(true);
        await onClick();
        getCoreUIStore().buttonLocked.set(false);
      }}
      isEnabled={isButtonEnabled}
    >
      <Et3Text
        fontFamily={fontType}
        fontSize={fontSize}
        text={i18n.get(text)}
        isSpan={false}
        color={colors.all.white}
        style={{}}
      />
    </Et3CustomizedButton>
  );
});
export default Et3Button;
